module.exports = __webpack_public_path__ + "img/slogan_cn.bb7bb5f2.png";